<template>
  <obj-page-container
    :headline="$t('impressum')"
    style="padding:0 1.25rem;width:900px; margin:3rem auto;">
    <cbr-corporate-information/>
  </obj-page-container>
</template>

<script>
import {mapState} from 'vuex'
import CbrCorporateInformation from '../components/CbrCorporateInformation.vue'
import ObjPageContainer from '../components/ObjPageContainer.vue'

export default {
  components: {
    ObjPageContainer,
    CbrCorporateInformation
  },

  computed: {
    ...mapState('lang', ['currentLanguage'])
  },
}
</script>



// WEBPACK FOOTER //
// client/views/ImpressumPage.vue